export const mapDataForBackend = (customer) => ({
  firstname: customer.firstName,
  lastname: customer.lastName,
  address: customer.address,
  email: customer.email,
  mobilephone: customer.mobile,
});
